module.exports = __webpack_public_path__ + "static/media/qa.4f43367e.svg";